document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.exxtra-service-journey').forEach(section => {

    const services = section.querySelectorAll('.exxtra-service');
    const links = section.querySelectorAll('.exxtra-sidebar__link');
    if (services.length) {

    const first = services[0];

    const cta = section.querySelector("#exxtra-sidebar-cta");
    const label = section.querySelector("#exxtra-cta-label");
    const heading = section.querySelector("#exxtra-cta-heading");
    const description = section.querySelector("#exxtra-cta-description");
    const button = section.querySelector("#exxtra-cta-button");

    if (cta)
      cta.style.setProperty(
        "--cta-bg",
        "var(--" + first.dataset.ctaBackground + ")"
      );

    if (label)
      label.textContent = first.dataset.ctaLabel;

    if (heading)
      heading.textContent = first.dataset.ctaHeading;

    if (description)
      description.textContent = first.dataset.ctaDescription;

    if (button) {
      button.textContent = first.dataset.ctaButton;
      button.href = first.dataset.ctaLink;
    }

  }

    if (!services.length || !links.length) return;

    /* -----------------------------
       Smooth Scroll
    ------------------------------*/

    links.forEach(link => {

      link.addEventListener('click', e => {

        e.preventDefault();

        const target = document.querySelector(link.getAttribute('href'));

        if (!target) return;

        const headerHeight =
          document.querySelector('header')?.offsetHeight || 0;

        const offset = 24;

        window.scrollTo({
          top:
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight -
            offset,
          behavior: 'smooth'
        });

      });

    });

    /* -----------------------------
       Active Navigation
    ------------------------------*/

    const observer = new IntersectionObserver(

      entries => {

        entries.forEach(entry => {

          if (!entry.isIntersecting) return;

          const id = entry.target.id;

          const service = entry.target;

          const cta = section.querySelector("#exxtra-sidebar-cta");
          const label = section.querySelector("#exxtra-cta-label");
          const heading = section.querySelector("#exxtra-cta-heading");
          const description = section.querySelector("#exxtra-cta-description");
          const button = section.querySelector("#exxtra-cta-button");

          if (cta)
            cta.style.setProperty(
              "--cta-bg",
              "var(--" + service.dataset.ctaBackground + ")"
            );

          if (label)
            label.textContent = service.dataset.ctaLabel;

          if (heading)
            heading.textContent = service.dataset.ctaHeading;

          if (description)
            description.textContent = service.dataset.ctaDescription;

          if (button) {
            button.textContent = service.dataset.ctaButton;
            button.href = service.dataset.ctaLink;
          }

          links.forEach(link => {

            link.classList.toggle(
              'active',
              link.getAttribute('href') === '#' + id
            );

          });

        });

      },

      {
        root: null,
        rootMargin: '-30% 0px -55% 0px',
        threshold: 0
      }

    );

    services.forEach(service => observer.observe(service));

  });

});